module.exports = __webpack_public_path__ + "static/media/lime-circle.aaaa63a2.svg";